/**
 * ONLY EDIT THIS FILE WITHIN CLIENT FOLDERS TO OVERRIDE MAIN CONFIG
 */
export default {};
